import React, { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import { getBrandList } from "store/actions/brandsAction"

const useBrandOptions = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const { brandList } = useSelector(state => state.Brands)

  useEffect(() => {
    dispatch(getBrandList())
  }, [dispatch])

  const allowedBrands = useMemo(() => {
    return (brandList || []).filter(brand => brand.status !== 0)
  }, [brandList])

  const options = useMemo(() => {
    return allowedBrands.map(brand => ({
      value: brand._id,
      label: brand.brandName,
    }))
  }, [allowedBrands, i18n.language])

  return {
    options,
    allowedBrands,
    hasOnlyOneBrand: allowedBrands?.length === 1,
  }
}

export default useBrandOptions
